import { Component, HostListener } from '@angular/core';
import { LoggerService } from '../../core/services/logger.service';
import { LoginService } from '../../core/services/login.service';
import { ContactCenterPFService } from 'src/app/data/CXOne/services/contact-center-pf.service';
import {
  VoiceCallDirection,
  VoiceCallEventDTO,
  VoiceCallEventType,
} from './domain/ContactCenter/VoiceCallEventDTO';
import { modalUraAutenticadora } from 'src/app/shared/services/modal-ura-autenticadora.services';
import { SendReloadScreenSignalService } from 'src/app/shared/services/sendReloadScreenSignalService';
import { LocalStorageUtils } from 'src/app/data/CXOne/util/LocalStorageUtils';
import { SessionStorageUtils } from 'src/app/data/CXOne/util/SessionStorageUtils';
import { JsonConverterUtils } from 'src/app/data/CXOne/util/JsonConverterUtils';
import { DynamicsOuvidoria } from 'src/app/data/Dynamics/ouvidoria/dynamics-ouvidoria.service';
@Component({
  selector: 'app-ouvidoria',
  standalone: true,
  imports: [],
  templateUrl: './ouvidoria.component.html',
  styleUrl: './ouvidoria.component.css',
})
export class OuvidoriaComponent {
  private agentNextState = '';
  private isReloadedSession = false;

  constructor(
    private logger: LoggerService,
    private dynamics: DynamicsOuvidoria,
    private loginService: LoginService,
    private contactCenterService: ContactCenterPFService,
    private modalUraAuth: modalUraAutenticadora,
    private sendReloadScreenSignalService: SendReloadScreenSignalService,
    private localStorageUtils: LocalStorageUtils,
    private jsonConverterUtils: JsonConverterUtils,
    private sessionStorageUtils: SessionStorageUtils,
  ) {
    this.isReloadedSession = sendReloadScreenSignalService.interactionIdExist();
  }

  @HostListener('window:beforeunload', ['$event'])
  handleBeforeUnload(event: BeforeUnloadEvent): void {
    this.sendReloadScreenSignalService.sendReloadSignal();
    event.preventDefault();
    event.returnValue = '';
  }

  async ngOnInit() {
    this.logger.info('Ouvidoria - inicializado.');
    const centralId =
      this.localStorageUtils.safeGetItem('centralId') || 'ouvidoria';
    const authServiceType =
      this.localStorageUtils.safeGetItem('authServiceType') || 'nice';
    const authMode =
      this.localStorageUtils.safeGetItem('display_mode') || 'popup';

    try {
      const isAuthenticated = await this.loginService.login(
        authServiceType,
        centralId,
        true,
        authMode,
      );

      if (isAuthenticated) {
        this.sessionStorageUtils.safeSetSessionItem('msdyn_ciDebug', 'true');
        this.logger.info('Usuario autenticado.');

        await this.contactCenterService.initializer();
        this.logger.info(
          'Serviço de Contact Center ouvidoria inicializado com sucesso.',
        );

        await this.dynamics.initialize();
        this.logger.info(
          'Serviço de Dynamics ouvidoria inicializado com sucesso.',
        );
      }
    } catch (error) {
      this.logger.error(error);
      window.alert('Falha no login.');
    }

    this.addEvents();
    this.logger.info('Eventos adicionados com sucesso.');
    this.logger.info('Inicialização concluída.');
  }

  private addEvents() {
    this.contactCenterService.onAgentStatusEvent$.subscribe(
      (agentStateEvent) => {
        this.logger.info(
          'Evento do Agente State recebido',
          this.jsonConverterUtils.JsonStringfy(agentStateEvent),
        );
        this.agentNextState = agentStateEvent.agentNextState;
        this.modalUraAuth.controlModalWithDefaultMessageAndTimer(
          this.agentNextState,
        );
      },
    );

    this.contactCenterService.onVoiceCallEvent$.subscribe((voiceCallEvent) => {
      this.logger.info(
        'Evento de voz recebido: ',
        this.jsonConverterUtils.JsonStringfy(voiceCallEvent),
      );

      switch (voiceCallEvent.CallStatus) {
        case VoiceCallEventType.Answered: {
          this.OnVoiceCallAnswered(voiceCallEvent);
          break;
        }
        case VoiceCallEventType.Released: {
          this.OnVoiceCallReleased(voiceCallEvent);
        }
      }
    });

    this.contactCenterService.onFocusEvent$.subscribe((FocusEvent) => {
      this.logger.info(
        'Solicitação de foco recebida: ',
        this.jsonConverterUtils.JsonStringfy(FocusEvent),
      );

      this.localStorageUtils.safeSetItem('interactionFocused', FocusEvent.Id);
      this.dynamics.ChangeSessionFocus(FocusEvent.Id);
    });

    this.dynamics.onAddUserIdOnAttachData$.subscribe(async (command) => {
      this.contactCenterService.AddCrmUserIdOnAttachData(
        command.interactionId,
        command.crmUserId,
      );
    });
  }

  private async OnVoiceCallAnswered(voiceCallEvent: VoiceCallEventDTO) {
    if (
      voiceCallEvent.CallDirection === VoiceCallDirection.Outbound &&
      !voiceCallEvent.AttachData?.CALLBACK
    ) {
      this.logger.info(
        `Ouvidoria (ACD - Contato não é inbound, não executando a criação de ticket no dynamics`,
      );
      return;
    }

    await this.dynamics.openTicket(
      voiceCallEvent.Id,
      voiceCallEvent.AttachData,
      true,
      voiceCallEvent.Id,
      'voice',
    );
    this.sendReloadScreenSignalService.setInteractionIdInLocalStorage(
      voiceCallEvent.Id,
    );
  }

  private async OnVoiceCallReleased(voiceCallEvent: VoiceCallEventDTO) {
    if (
      voiceCallEvent.CallDirection === VoiceCallDirection.Outbound &&
      !voiceCallEvent.AttachData?.CALLBACK
    ) {
      this.logger.info(
        `Ouvidoria (ACD - Contato não é inbound e não é callback, não executando o encerramento de ticket no dynamics`,
      );
      return;
    }

    if (this.agentNextState === 'Autenticadora') {
      this.logger.info('Transferência para Ura detectada');
      await this.dynamics.customerTransferedAuthIVR(
        voiceCallEvent.Id,
        voiceCallEvent.AttachData,
        'voice',
      );
      return;
    }

    if (voiceCallEvent.DisconectCode === 'TransferComplete') {
      this.logger.info('Transferência detectada');
      await this.dynamics.customerTransfered(
        voiceCallEvent.Id,
        voiceCallEvent.AttachData,
        'voice',
      );
      return;
    }

    if (this.isReloadedSession === true) {
      this.sendReloadScreenSignalService.removeInteractionIdInLocalStorage();
      this.isReloadedSession = false;
    } else {
      await this.dynamics.endTicket(
        voiceCallEvent.Id,
        voiceCallEvent.AttachData,
        'voice',
      );
    }
  }
}
